const FLOW_KEY = 'kp_visit_flow'
const PAGE_CLIP = 300
const REFERRER_CLIP = 1000
const UA_CLIP = 500

function clip(value, max) {
  return String(value || '').trim().slice(0, max)
}

function currentPage() {
  return clip(`${location.pathname}${location.search}${location.hash}`, PAGE_CLIP)
}

function isExternalUrl(value) {
  try {
    const url = new URL(value)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
    return url.origin !== location.origin
  } catch (e) {
    return false
  }
}

/** 地址栏里有时会带 from / ref，用来补 document.referrer 被微信、Telegram 清掉的情况 */
function sourceFromQuery(search) {
  const params = new URLSearchParams(search || location.search)
  const keys = ['from', 'ref', 'referrer', 'source', 'url']
  for (let i = 0; i < keys.length; i++) {
    const raw = (params.get(keys[i]) || '').trim()
    if (isExternalUrl(raw)) return clip(raw, REFERRER_CLIP)
  }
  const utm = (params.get('utm_source') || '').trim()
  if (isExternalUrl(utm)) return clip(utm, REFERRER_CLIP)
  return ''
}

/** 只记站外网站。本站自己跳来跳去不算来源。 */
function captureExternalSource() {
  const ref = (document.referrer || '').trim()
  if (isExternalUrl(ref)) return clip(ref, REFERRER_CLIP)
  return sourceFromQuery()
}

function persist(data) {
  try {
    sessionStorage.setItem(FLOW_KEY, JSON.stringify(data))
  } catch (e) {
    /* 隐私模式写不进 session 时，点击上报再现场记 */
  }
}

function readStored() {
  try {
    const raw = sessionStorage.getItem(FLOW_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (!data || typeof data.landedAt !== 'number') return null
    return data
  } catch (e) {
    return null
  }
}

/**
 * 本标签页第一次打开时记下入口和站外来源。
 * 来源只收第一次外部网站，后面在站内点来点去不会覆盖。
 */
export function rememberVisit() {
  const source = captureExternalSource()
  const existing = readStored()
  if (!existing) {
    persist({
      landedAt: Date.now(),
      entry: currentPage(),
      referrer: source,
    })
    return
  }
  if (!existing.referrer && source) {
    persist(Object.assign({}, existing, { referrer: source }))
  }
}

function navigationType() {
  const entries = performance.getEntriesByType ? performance.getEntriesByType('navigation') : []
  const entry = entries && entries[0]
  return (entry && entry.type) || 'unknown'
}

/** 微信 / QQ 内置浏览器可以从 UA 判定，即使 referrer 是空的。 */
function detectInApp(ua) {
  const mini = window.__wxjs_environment === 'miniprogram'
  if (mini || (/miniProgram/i.test(ua) && /MicroMessenger/i.test(ua))) return 'wechat-mini'
  if (/MicroMessenger/i.test(ua)) return 'wechat'
  if (/\bQQ\//i.test(ua)) return 'qq'
  if (/Weibo/i.test(ua)) return 'weibo'
  if (/AlipayClient/i.test(ua)) return 'alipay'
  if (/DingTalk/i.test(ua)) return 'dingtalk'
  if (/Telegram/i.test(ua)) return 'telegram'
  return ''
}

function inAppNetType(ua) {
  const matched = ua.match(/NetType\/([A-Za-z0-9]+)/i)
  return ((matched && matched[1]) || '').toUpperCase()
}

/** 点击下载时带上的访问过程。referrer 是跳过来的站外完整地址。 */
export function visitContext() {
  const stored = readStored()
  const referrer = (stored && stored.referrer) || captureExternalSource()
  const landedAt = (stored && stored.landedAt) || Date.now()
  const ua = clip(navigator.userAgent || '', UA_CLIP)
  return {
    entry: clip((stored && stored.entry) || currentPage(), PAGE_CLIP),
    page: currentPage(),
    referrer,
    direct: referrer ? '0' : '1',
    stayMs: Math.max(0, Date.now() - landedAt),
    nav: navigationType(),
    visible: document.visibilityState || '',
    focus: document.hasFocus() ? '1' : '0',
    webdriver: navigator.webdriver ? '1' : '0',
    history: String((window.history && history.length) || 0),
    ua,
    inApp: detectInApp(ua),
    netType: inAppNetType(ua),
  }
}
